import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid ps-0" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-6 d-flex align-items-center" }
const _hoisted_5 = ["data-bs-target", "disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "breadcrumb" }
const _hoisted_9 = { class: "breadcrumb-item" }
const _hoisted_10 = {
  key: 0,
  class: "breadcrumb-item"
}
const _hoisted_11 = {
  key: 1,
  class: "breadcrumb-item active"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'theBreadcrumbs',
  props: {
    title: {
        default: 'home'
    },
    main: {
        default: ''
    },
    modal: {
        default: ''
    },
    rout: {
        default: ''
    },
    buttonLabel: {
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

let props = __props

return (_ctx: any,_cache: any) => {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (__props.modal)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-info",
                type: "button",
                "data-bs-toggle": "modal",
                "data-original-title": "test",
                "data-bs-target": '#' + __props.modal,
                disabled: __props.disabled
              }, "New", 8, _hoisted_5))
            : _createCommentVNode("", true),
          (__props.buttonLabel)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('buttonClick'))),
                disabled: __props.disabled
              }, _toDisplayString(__props.buttonLabel), 9, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ol", _hoisted_8, [
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createVNode(_component_vue_feather, { type: "home" })
                ]),
                _: 1
              })
            ]),
            (__props.main)
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, _toDisplayString(__props.main), 1))
              : _createCommentVNode("", true),
            (__props.title)
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString(__props.title), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})